<template>
    <div v-if="visible" class="loading-overlay">
      <div class="loader"></div>
      <div class="loading-text">{{ text }}</div>
    </div>
</template> 

<script>
export default {
    name: 'LoadingComp',
    props: {
        visible: {
            type: Boolean,
            default: false
        }, 
        text: {
            type: String,
            default: 'Đang tải dữ liệu...'
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255,255,255,0.7);
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
	flex-direction: column;
}

.loader {
  width: 60px;
  aspect-ratio: 2;
  --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);
  background: 
    var(--_g) 0%   50%,
    var(--_g) 50%  50%,
    var(--_g) 100% 50%;
  background-size: calc(100%/3) 50%;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
    20%{background-position:0%   0%, 50%  50%,100%  50%}
    40%{background-position:0% 100%, 50%   0%,100%  50%}
    60%{background-position:0%  50%, 50% 100%,100%   0%}
    80%{background-position:0%  50%, 50%  50%,100% 100%}
}
.loading-text {
    font-size: 16px;
    font-weight: 500;
    color: #000;
    margin-top: 10px;
}
</style>